import React from "react";
const SvgMapColumnsCollapse = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M16.53 2.97a.75.75 0 010 1.06L8.56 12l7.97 7.97a.75.75 0 11-1.06 1.06l-8.5-8.5a.75.75 0 010-1.06l8.5-8.5a.75.75 0 011.06 0z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMapColumnsCollapse;
